import { useContext } from 'react';

// Providers.
import { EditableContext, IEditableContext } from 'providers';

export const useEditableContext = (): IEditableContext => {
  return useContext(EditableContext);
};
